<div class="loaderwrapper" *ngIf="this.loader">
    <span class="loader"></span>
</div>
<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="card table-card mb-4">
            <!-- Title, filters and the page action share one row at the top
                 of the card rather than stacking above it. -->
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Sub Category</h1>
                <button type="button" class="btn btn-dark rounded" (click)="addSubCategory(content)"
                    *ngIf="permissionsReady && permissions.canAdd">
                    <i class="ri-add-line label-icon align-middle fs-16"></i>
                    Add New
                </button>
            </div>
            <div class="table-wrap" [class.is-loading]="tableLoader">
                <div class="loaderwrapper" *ngIf="tableLoader">
                    <span class="loader"></span>
                </div>
                <div class="table-main">
                    <table class="table-data">
                        <thead>
                            <tr>
                                <th scope="col">Sr. No</th>
                                <th scope="col">Sub Category Name</th>
                                <th scope="col">Category Name</th>

                                <th scope="col" style="width: 80px;text-align: center;">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of getSubcat; let i = index">
                                <td>{{ i+1 }}</td>

                                <td>{{ item.getSubCategoryName() }}</td>
                                <td>{{ item.getCategoryName() }}</td>


                                <td style="width: 40px;text-align: center">
                                    <div class="  d-flex justify-content-center">
                                        <button type="button" (click)="open(item, content)"
                                            class="dropdown-item editcategory d-inline" data-toggle="modal"
                                            data-target="#edit-category-vt">

                                            <!-- <i class="bx bx-edit"></i> -->
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.433" height="18"
                                                viewBox="8 4 14.433 18">
                                                <path
                                                    d="M8.9 20.2h12.6a.9.9 0 0 1 0 1.8H8.9a.9.9 0 1 1 0-1.8ZM8 15.7l9-9 2.7 2.7-9 9H8v-2.7Zm9.9-9.9L19.7 4l2.7 2.7-1.8 1.8-2.7-2.7Z"
                                                    fill="currentColor" />
                                            </svg>
                                        </button>
                                        <button (click)="deleteSubCategory(item)" type="button"
                                            class="dropdown-item deletecategory d-inline">
                                            <!-- <i class=" ri-close-circle-line  "></i>  -->
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15.017" height="18"
                                                viewBox="9 6 15.017 18">
                                                <path
                                                    d="M10.5 22.004c0 1.098.9 1.996 2 1.996h8c1.1 0 2-.898 2-1.996V10.5h-12v11.504ZM24 7.5h-3.75L18.994 6h-4.988L12.75 7.5H9V9h15V7.5Z"
                                                    fill="currentColor" />
                                            </svg>

                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #content let-c="close" let-d="dismiss">
    <!-- (ngSubmit)="cardDetail(payment,content)" #payment="ngForm" -->
    <form [formGroup]="addSubCategoryForm" (ngSubmit)="submitSubCategory()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Add Sub Category</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25"
                    viewBox="1222.583 108.567 13.633 14.25">
                    <g data-name="Group 2829">
                        <g data-name="chevron-back">
                            <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                                stroke-width="2" stroke="#fff" fill="transparent" data-name="Path 5498" />
                        </g>
                        <g data-name="chevron-back">
                            <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round"
                                stroke-linecap="round" stroke-width="2" stroke="#fff" fill="transparent"
                                data-name="Path 5498" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 mb-3 form-styles">
                    <label for="typeahead-basic">Sub-Category Name:</label>
                    <input id="typeahead-basic" type="text" class="form-control" formControlName="subCatName"
                        maxlength="50">

                    <small class="text-danger" *ngIf="
                            !addSubCategoryForm.get('subCatName').valid &&
                            addSubCategoryForm.get('subCatName').touched
                        ">Please Enter Sub-Category Name</small>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 form-styles">
                    <label for="typeahead-basic">Category Name:</label>
                    <ng-select formControlName="catName">
                        <ng-option *ngFor="let sourceList1 of getcat" [value]="sourceList1.id">{{
                            sourceList1.category_name }}</ng-option>
                    </ng-select>
                    <small class="text-danger" *ngIf="
                            !addSubCategoryForm.get('catName').valid &&
                            addSubCategoryForm.get('catName').touched
                        ">Please Enter Category Name</small>
                </div>
            </div>
        </div>
        <!-- (click)="c('Save click')" -->
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
                Cancel
            </button>
            <button type="button" class="btn btn-orange" [disabled]="addSubCategoryForm.invalid"
                (click)="d('Cross click')" type="submit">
                Save
            </button>
        </div>
    </form>
</ng-template>


<ng-template #contentupdate let-c="close" let-d="dismiss">
    <!-- (ngSubmit)="cardDetail(payment,content)" #payment="ngForm" -->
    <form [formGroup]="updateSubCategoryForm" (ngSubmit)="updatesubmitSubCategory()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Update Sub Category</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
                <svg xmlns="http://www.w3.org/2000/svg" width="13.633" height="14.25"
                    viewBox="1222.583 108.567 13.633 14.25">
                    <g data-name="Group 2829">
                        <g data-name="chevron-back">
                            <path d="m1224 110 5.393 5.393 5.393-5.393" stroke-linejoin="round" stroke-linecap="round"
                                stroke-width="2" stroke="#fff" fill="transparent" data-name="Path 5498" />
                        </g>
                        <g data-name="chevron-back">
                            <path d="m1224 121.393 5.393-5.393 5.392 5.393" stroke-linejoin="round"
                                stroke-linecap="round" stroke-width="2" stroke="#fff" fill="transparent"
                                data-name="Path 5498" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 mb-3 form-styles">
                    <label for="typeahead-basic">Sub-Category Name:</label>
                    <input id="typeahead-basic" type="text" class="form-control" formControlName="subCatName1"
                        maxlength="50" />
                    <small class="text-danger" *ngIf="
                            !updateSubCategoryForm.get('subCatName1').valid &&
                            updateSubCategoryForm.get('subCatName1').touched
                        ">Please Enter Sub-Category Name</small>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 form-styles">
                    <label for="typeahead-basic">Category Name:</label>
                    <ng-select formControlName="catName1">
                        <ng-option *ngFor="let sourceList1 of getcat" [value]="sourceList1.id">{{
                            sourceList1.category_name }}</ng-option>
                    </ng-select>
                    <small class="text-danger" *ngIf="
                            !updateSubCategoryForm.get('catName1').valid &&
                            updateSubCategoryForm.get('catName1').touched
                        ">Please Enter Category Name</small>
                </div>
            </div>
        </div>
        <!-- (click)="c('Save click')" -->
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click')">
                Cancel
            </button>
            <button type="button" class="btn btn-orange" [disabled]="updateSubCategoryForm.invalid"
                (click)="d('Cross click')" type="submit">
                Save
            </button>
        </div>
    </form>
</ng-template>